import { useNavigate } from "react-router-dom";

export const pages = [
    {
        route: "/playground",
        label: "Components",
    },
    {
        route: "/playground/carousels",
        label: "Carousels",
    },
   
]

export const NavBar = () => {

    const navigateTo = useNavigate();

    return (
        <nav className="nav-bar">
            {pages.map((page, index) => (
                <>
                <button 
                    className="nav-button-container" 
                    onClick={() => navigateTo(page.route)}
                    key={index}
                >
                    <span className="nav-button">{page.label}</span>
                </button>
                {" |"}
                </>
            ))}
        </nav>
    );

}